import { createFileRoute } from "@tanstack/react-router";

import { WarehousesAdminPage } from "./_app.erp.settings.warehouses";

export const Route = createFileRoute("/_app/settings/warehouses")({
  component: WarehousesAdminPage,
});
